import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TAvailableReportsResponse,
	TAvailableReportsSearchRequest,
	TDownloadAvailableReportRequest,
	TReportsStore,
	TReportType,
} from './types';
import { REPORTS_SLICE_NAME } from './constants';

const initialState: TReportsStore = {
	reportTypes: null,
	reportTypesLoading: false,
	availableReports: null,
	availableReportsLoading: false,
	downloadingReportIds: [],
};

const reportsSlice = createSlice({
	name: REPORTS_SLICE_NAME,
	initialState,
	reducers: {
		// Report types
		getReportTypesRequest: (state) => {
			state.reportTypesLoading = true;
		},
		getReportTypesSuccess: (state, action: PayloadAction<TReportType[]>) => {
			state.reportTypes = action.payload;
			state.reportTypesLoading = false;
		},
		getReportTypesFailure: (state) => {
			state.reportTypesLoading = false;
		},

		// Available reports
		searchAvailableReportsRequest: (
			state,
			_action: PayloadAction<TAvailableReportsSearchRequest>,
		) => {
			state.availableReportsLoading = true;
		},
		searchAvailableReportsSuccess: (state, action: PayloadAction<TAvailableReportsResponse>) => {
			state.availableReports = action.payload;
			state.availableReportsLoading = false;
		},
		searchAvailableReportsFailure: (state) => {
			state.availableReportsLoading = false;
		},

		// Download available report
		downloadAvailableReportRequest: (
			state,
			action: PayloadAction<TDownloadAvailableReportRequest>,
		) => {
			if (!state.downloadingReportIds.includes(action.payload.id)) {
				state.downloadingReportIds.push(action.payload.id);
			}
		},
		downloadAvailableReportFinished: (state, action: PayloadAction<number>) => {
			state.downloadingReportIds = state.downloadingReportIds.filter((id) => id !== action.payload);
		},
	},
});

export const {
	getReportTypesRequest,
	getReportTypesSuccess,
	getReportTypesFailure,
	searchAvailableReportsRequest,
	searchAvailableReportsSuccess,
	searchAvailableReportsFailure,
	downloadAvailableReportRequest,
	downloadAvailableReportFinished,
} = reportsSlice.actions;

export default reportsSlice.reducer;
